import React from 'react';
import { ColorModeProvider } from './color-mode';

import {
  ChakraProvider as BaseChakraProvider,
  createSystem,
  defaultConfig,
  defineConfig,
} from '@chakra-ui/react';

const customConfig = defineConfig({
  theme: {
    config: {
      initialColorMode: 'light',
      useSystemColorMode: false,
    },
    tokens: {
      colors: {
        brand: {
          50: { value: '#eee6f8' },
          100: { value: '#d2c2ed' },
          200: { value: '#b49ae3' },
          300: { value: '#9670d8' },
          400: { value: '#7f50cf' },
          500: { value: '#6730c6' },
          600: { value: '#5d2bc0' },
          700: { value: '#4e23b7' },
          800: { value: '#401cb0' },
          900: { value: '#240da5' },
        },
        lightGreyText: { value: '#717171' },
        almostBlack: { value: '#222222' },
      },
    },
  },
});

const system = createSystem(defaultConfig, customConfig);

export default function Provider(props) {
  return (
    <BaseChakraProvider value={system}>
      <ColorModeProvider {...props} />
    </BaseChakraProvider>
  );
}
